import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/settings/_panel/quoting/task-groups/",
)({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
